<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
      <el-button v-if="hasPermsExport" @click="jumpExport">按条件导出数据</el-button>
    </el-button-group>

    <el-table :data="adviceApplies" resource="advice-applies" v-loading="loading">
      <el-table-column align="center" header-align="center" label="申请人" width="190">
        <template slot-scope="scope">
          <div v-if="scope.row.applier_user">
            <span>{{ scope.row.applier_user.real_name }}({{ scope.row.applier_user.level_info.level_name }})</span>
            <br />
            <span>{{ scope.row.applier_user.mobile }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" header-align="center" label="报单人" width="190">
        <template slot-scope="scope">
          <div v-if="scope.row.rel_user">
            <span>{{ scope.row.rel_user.real_name }}({{ scope.row.rel_user.level_info.level_name }})</span>
            <br />
            <span>{{ scope.row.rel_user.mobile }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="bill_amount" label="报单金额" />
      <!-- <el-table-column prop="fee_amount" label="手续费" />
      <el-table-column prop="amount" label="使用奖金" /> -->

      <el-table-column label="支付信息" width="190">
        <template slot-scope="scope">
          {{ scope.row.pay_status_text }}
          <br />
          <span>{{ scope.row.pay_order_no }}</span>
        </template>
      </el-table-column>

      <el-table-column label="凭证" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.voucher">
            <el-image :src="scope.row.voucher" :preview-src-list="[scope.row.voucher]">
              <div slot="error" class="image-slot"><i class="el-icon-picture-outline" /></div>
            </el-image>
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" header-align="center" label="状态" width="180">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.debit_advice_status === 0" type="info" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.debit_advice_status === 1" type="warning" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.debit_advice_status === 2" type="success" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.debit_advice_status === 3" type="danger" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <br />
          <span>
            {{ scope.row.op_name }}
            <br />
            {{ scope.row.check_time }}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="申请时间" width="170" />
      <el-table-column prop="remark" label="用户备注" />

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button-group>
            <el-tooltip effect="dark" content="报单审核" placement="top">
              <el-button
                size="small"
                v-if="scope.row.debit_advice_status === 1 && scope.row.pay_status === 0 && hasPermsChangeAdviceStatus"
                divided
                @click="onChangeAdviceStatus(scope.$index, scope.row)"
                >审核</el-button
              >
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-dialog title="审核" :visible.sync="setAdviceStatusDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="form"
        :submit="onAdviceStatusSubmit"
        :errors.sync="errors"
        :form.sync="form"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="审核状态" required>
          <el-select v-model="form.status" placeholder="请选择">
            <el-option label="审核成功" value="2" />
            <el-option label="审核失败" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" v-model="form.remark" />
        </el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getAdviceApplies, changeAdviceStatus, exportAdvanceApplies } from '@/api/advice-applies'
import LzForm from '@c/LzForm'
import { getFirstError, can } from '@/libs/utils'
import { Loading } from 'element-ui'
import { downFile } from '@/libs/download-helper'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
    LzForm,
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '手机/姓名',
        },
        {
          field: 'pay_order_no',
          label: '支付订单号',
        },
        {
          field: 'pay_status',
          label: '支付类型',
          type: 'el-select',
          options: [
            // {
            //   id: 0,
            //   name: '线下支付',
            // },
            {
              id: 1,
              name: '微信支付',
            },
          ],
          labelField: 'name',
          valueField: 'id',
        },
        {
          field: 'debit_advice_status',
          label: '审核状态',
          type: 'el-select',
          options: [
            {
              id: 0,
              name: '待申请',
            },
            {
              id: 1,
              name: '审核中',
            },
            {
              id: 2,
              name: '审核成功',
            },
            {
              id: 3,
              name: '审核失败',
            },
          ],
          labelField: 'name',
          valueField: 'id',
        },
        {
          field: 'created_at',
          label: '创建时间',
          type: 'el-date-picker',
        },
      ],
      setAdviceStatusDialog: false,
      form: {
        id: 0,
        status: 0,
        remark: '',
      },
      errors: {},
      adviceApplies: [],
      page: null,
      loading: true,
      query: {},
      hasPermsChangeAdviceStatus: false,
      hasPermsExport: false,
    }
  },
  created() {
    this.hasPermsChangeAdviceStatus = can('advice-applie.change-advice-status')
    this.hasPermsExport = can('advice-applies.export')
  },
  methods: {
    async loadData(newVal) {
      const {
        data: { data, meta },
      } = await getAdviceApplies(newVal)
      this.adviceApplies = data
      this.page = meta
      this.loading = false
    },
    async onChangeAdviceStatus(index, row) {
      this.setAdviceStatusDialog = true
      this.form = {
        id: row.id,
        status: '',
        remark: '',
      }
    },
    async onAdviceStatusSubmit() {
      try {
        const { data } = await changeAdviceStatus(this.form)
        this.setAdviceStatusDialog = false
        this.$message.success(data)
        this.clearForm()
        await this.loadData({})
      } catch (e) {
        console.log(e)
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    clearForm() {
      this.form = {
        id: 0,
        status: '',
        remark: '',
      }
    },
    async jumpExport() {
      const loadingInstance = Loading.service({ target: document.querySelector('.loading-area'), text: '下载中...' })
      const { data } = await exportAdvanceApplies(this.query).setConfig({ responseType: 'blob' })
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      downFile(blob, 'advance-apply.xlsx')
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close()
      })
    },
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        this.loadData(newVal.query)
      },
      immediate: true,
    },
  },
  setAdviceStatusDialog(newVal) {
    if (!newVal) {
      this.clearForm()
    }
  },
}
</script>
